
import CryptoJS from 'crypto-js';

export default function md5Hash(str) {
  return CryptoJS.enc.Base64.stringify(CryptoJS.MD5(CryptoJS.enc.Utf8.parse(str)));
}